var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_2802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 184
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.9998,
    cy: 91.66,
    r: 91.66,
    fill: "#1E1E1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_2802)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M355.881 735.774C261.787 777.205 67.4593 819.036 42.9 654.908C12.2009 449.748 97.9337 103.822 -299.657 -31.3289",
    stroke: "url(#paint0_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M377.221 729.477C283.127 770.908 88.7991 812.739 64.2399 648.611C33.5408 443.452 119.274 97.5252 -278.317 -37.6256",
    stroke: "url(#paint1_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M398.561 723.18C304.467 764.611 110.139 806.442 85.5797 642.314C54.8806 437.155 140.613 91.2282 -256.977 -43.9226",
    stroke: "url(#paint2_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M419.898 716.882C325.805 758.313 131.477 800.144 106.918 636.016C76.2185 430.857 161.951 84.9302 -235.639 -50.2206",
    stroke: "url(#paint3_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M441.24 710.585C347.146 752.016 152.819 793.847 128.259 629.719C97.5603 424.56 183.293 78.6332 -214.297 -56.5176",
    stroke: "url(#paint4_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M462.58 704.288C368.486 745.719 174.159 787.55 149.599 623.422C118.9 418.262 204.633 72.3361 -192.958 -62.8146",
    stroke: "url(#paint5_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.92 697.991C389.826 739.422 195.498 781.253 170.939 617.125C140.24 411.965 225.973 66.0391 -171.618 -69.1116",
    stroke: "url(#paint6_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M505.26 691.693C411.166 733.124 216.838 774.955 192.279 610.827C161.58 405.668 247.313 59.7412 -150.278 -75.4095",
    stroke: "url(#paint7_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M526.598 685.396C432.504 726.828 238.176 768.658 213.617 604.531C182.918 399.371 268.65 53.4446 -128.94 -81.7062",
    stroke: "url(#paint8_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.937 679.099C453.844 720.531 259.516 762.361 234.957 598.234C204.258 393.074 289.99 47.1476 -107.6 -88.0032",
    stroke: "url(#paint9_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M569.277 672.802C475.183 714.234 280.856 756.064 256.297 591.936C225.597 386.777 311.33 40.8505 -86.2603 -94.3003",
    stroke: "url(#paint10_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M590.615 666.505C496.521 707.937 302.194 749.767 277.634 585.64C246.935 380.48 332.668 34.5535 -64.9224 -100.597",
    stroke: "url(#paint11_linear_297_2802)",
    strokeWidth: 7.3328
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M611.955 660.208C517.861 701.639 323.534 743.47 298.974 579.342C268.275 374.183 354.008 28.2562 -43.5826 -106.895",
    stroke: "url(#paint12_linear_297_2802)",
    strokeWidth: 7.3328
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_2802",
    x1: 77.2773,
    y1: -31.329,
    x2: 77.2774,
    y2: 773.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_297_2802",
    x1: 98.6171,
    y1: -37.6256,
    x2: 98.6172,
    y2: 766.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_297_2802",
    x1: 119.957,
    y1: -43.9226,
    x2: 119.957,
    y2: 760.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_297_2802",
    x1: 141.295,
    y1: -50.2206,
    x2: 141.295,
    y2: 754.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_297_2802",
    x1: 162.637,
    y1: -56.5176,
    x2: 162.637,
    y2: 747.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_297_2802",
    x1: 183.977,
    y1: -62.8147,
    x2: 183.977,
    y2: 741.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_297_2802",
    x1: 205.316,
    y1: -69.1117,
    x2: 205.316,
    y2: 735.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_297_2802",
    x1: 226.656,
    y1: -75.4096,
    x2: 226.656,
    y2: 729.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_297_2802",
    x1: 247.994,
    y1: -81.7062,
    x2: 247.994,
    y2: 722.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_297_2802",
    x1: 269.334,
    y1: -88.0032,
    x2: 269.334,
    y2: 716.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_297_2802",
    x1: 290.674,
    y1: -94.3003,
    x2: 290.674,
    y2: 710.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_297_2802",
    x1: 312.012,
    y1: -100.597,
    x2: 312.012,
    y2: 703.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_297_2802",
    x1: 333.352,
    y1: -106.895,
    x2: 333.352,
    y2: 697.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagebg);
export default __webpack_public_path__ + "static/media/messagebg.7c827cb97dca78d920fe3478e5481754.svg";
export { ForwardRef as ReactComponent };